package team.platforma.auth_data.repository

import io.ktor.client.HttpClient
import io.ktor.client.request.request
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import team.platforma.auth_data.network.body.AuthBody
import team.platforma.auth_data.network.response.AuthResponse
import team.platforma.wrapper.Response
import team.platforma.wrapper.ResponseWrapper

class AuthRepositoryImpl(
    private val network: HttpClient
) : AuthRepository, ResponseWrapper() {
    override suspend fun auth(email: String, password: String): Response<AuthResponse> {
       return wrapResponse<AuthResponse>(
            network.request("web-api/auth"){
                contentType(ContentType.Application.Json)
                setBody(
                    AuthBody(
                        email = email,
                        password = password
                    )
                )
                method = HttpMethod.Post
            }
        )
    }
}